export default __webpack_public_path__ + "static/media/matti_xl.f78cc450.jpg";